module.exports = __webpack_public_path__ + "img/public_qr_code.ec889dd5.jpg";